export default {
  labels: {
    title: 'Detalle de cuenta',
    generalInformation: 'Información general',
    chargesList: 'Lista de cargos',
    reinvoicedAccounts: 'Cuentas refacturadas',
    accountSupports: 'Soportes de cuentas',
    supportsAdministrator: 'Administrador de soportes',
    pendingAccountSupportFiles: 'Soportes de cuenta faltantes',
    receivedAccountSupportFiles: 'Soportes de cuenta adjuntos',
    pendingProductConfiguration: 'Productos sin configurar. Revise los marcados en rojo en la lista de cargos',
    agreements: 'Configuración de convenio',
    baseAccount: 'Cuenta base',
    generateAccountTitle: '¿Desea armar cuenta?',
    generateAccountSubtitle: 'Esta cuenta tiene ({count}) documentos faltantes ¿está seguro que desea proceder? Esta acción no se puede deshacer o detener.',
    generateAccountButton: 'Armar cuenta',
    reGenerateAccountButton: 'Rearmar cuenta',
    statusTooltip: {
      label: 'Última vez actualizada el {date} a las {time} por {username}.',
      updatedBy: 'proceso automatizado'
    }
  },
	statuses: {
    PENDING: 'Pendiente',
    READY_TO_GENERATE: 'Listo para generar',
    GENERATED: 'Generado',
    VOIDED: 'Deshabilitado',
  },
  charges: {
    search: 'Buscar por ID de cargo',
    serviceType: 'Tipo de evento',
    from: 'Desde',
    to: 'Hasta',
    notRequire: 'No requiere',
    invoiceableFalse: 'No facturable',
    completed: 'Completada',
    notCompleted: 'No completada',
    serviceTypes: {
      hospitalization: 'Hospitalización',
      urgency: 'Urgencias',
      outpatientCare: 'Consulta externa',
      procedure: 'Procedimiento',
      exam: 'Examen',
    },
    grid: {
      chargeId: 'ID cargo',
      eventNumber: 'Evento',
      eventDate: 'Fecha de evento',
      invoiceAssigned: 'Facturado',
      eventId: 'Evento',
      serviceType: 'Tipo de evento',
      providerProductCode: 'Código producto',
      patientName: 'Nombre del paciente',
      chargeDescription: 'Descripción',
      creationDateTime: 'Fecha de creación',
      hasDocumentationComplete: 'Doc.',
      totalAmount: 'Monto ({currency})',
      hasAuditorComments: 'Comentarios',
      executorService: 'Especialidad'
    }
  },
  finalizedAuditProcess:{
    completeAudit: "Completar auditoría",
    uploadReconciliationRecord: "Cargar acta de conciliación",
    noAttachedFiles: "No hay archivos adjuntos",
    uploadRestrictions: "Archivos en formato PDF, PNG o JPEG, peso máximo 20Mb",
    withoutFileUploads: "Continuar sin documentación"
  }
}
